import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger, PanelGroup, Panel } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';

import CustomModal from "../../../components/Modal/CustomModal";

import{ PagarAranceles, PagarAllCuotas } from "../../../funciones/SolicitudesFunction";
import { ConsultaDeudaEst, ConsultCuentaAdminHist, consultCuotas } from "../../../funciones/EstCuentaFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import DatosInscripcion from "../../Inscripcion/DatosInscripcion";
import SelectCuota from './SelectCuota';

let errores = 0;
let fecha = new Date();

class EstDeudasTable extends Component {
    state = {
        boton2:{
            text: "Registrar Pago",
            icon: "fa fa-money"
        },
        boton3:{
            text: "Pago Completo",
            icon: "fa fa-check-square"
        },
        openPago: false,
        openPagoCompleto: false,
        otroMonto: "",
        total: true,
        otro: false,
        concepto: "",
        divisas: "",
        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
        metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
        num: "",
        modalPagoBtn1: {
            icon:"fa fa-money",
            text: "Registrar"
        },
        factura: "",
        deudaT: "",
        fecha: fecha,
        bsCambio: 0,

        metodos: this.props.metodos,
        cambio: this.props.cambio,
        cambio2: 0,
        cuentas: this.props.cuentas,
        nuCuenta: this.props.nuCuenta,
        openMaterias: false,
        openCuenta: false,
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
        asientos: [],
        cuotasP:[],
        registrarAllCuotas:{
            icon: "fa fa-money",
            text: "Registrar",
            disabled: false
        },
        asientosHist:[],
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,
        metodoPValue: "",
        metodoP: [],
        subTotal: "",
        igtfV: this.props.datos.ValorIGTF
    }

    componentDidMount = () => {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
          
        fetch("https://s3.amazonaws.com/dolartoday/data.json", requestOptions)
            .then(response => response.text())
            .then(result => {
                let data = JSON.parse(result);
                this.setState({
                    cambio2: data.USD.sicad2
                })

            })
            .catch(error => console.log('error', error));
        
        ConsultaDeudaEst (this.props.datos.id, (resp) => {
            errores = resp.errores;
            let porcentajeImp =  ((resp.totalGral) * (this.props.datos.ValorIGTF)) / 100;

            this.setState({
                deudaT: resp,
                subTotal: resp.totalGral,
                igtfV: porcentajeImp.toFixed(2)
            })
        })
        let contenido = [];
        
        contenido.push(this.props.metodos.find(option => option.label === "EFECTIVO"));
        contenido.push(this.props.metodos.find(option => option.label === "DIVISA"));

        this.setState({
            metodoPValue: contenido[0],
            metodoP: contenido 
        })
    }

    cambiaValorM = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    valorMetodo = (metodoSelect) => {
        this.setState({
            metodoSelect
        });
    }

    valorMetodoA = (metodoPValue) => {
        this.setState({
            metodoPValue
        });
    }

    valorCuenta = (selectcuenta) => {
        this.setState({
            selectcuenta
        });
    }

    cambiaValorDivisa = () => (event) => {
        if (!isNaN(Number(event.target.value)) === false) return null;
        let valorCambio = parseFloat(this.state.cambio) * parseFloat(event.target.value)
        if (event.target.value === "") valorCambio = 0;
        this.setState({
            divisas: event.target.value,
            bsCambio: valorCambio.toFixed(2)
        });
    };

    cambiaFecha = (date) => {
        this.setState({
            openHome: false,
            fecha: date
        });
    }

    pagar = (prop) => {
        this.setState({
            total: false,
            otro: false,
        }, () => { 
            this.setState({[prop]: true})
        })
    }

    modalPago = () => {
        let { datos } = this.props;

        const { openPago, modalPagoBtn1, metodoSelect, metodos, total, otro, otroMonto, deudaT, concepto, fecha,
            cambio, divisas, bsCambio, selectcuenta, cuentas, num, factura, subTotal, igtfV, cambio2
        } = this.state;
        let campos = {metodoSelect, divisas, bsCambio, num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta,
            factura, igtfV};
        const styles = {
            padding: 2, fontSize: 12
        }

        let montoPayEf = () => (
            <div className="table-responsive">
                <Table bordered style={{marginBottom: 0}}>
                    <tbody>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                            </td>
                        </tr>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="number" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )

        let igtf = () => {
            let porcentajeImp =  ((subTotal) * (igtfV)) / 100;
            return porcentajeImp.toFixed(2);
        }

        let totalAPagar = () => {
            return (parseFloat(subTotal) + parseFloat(igtfV)).toFixed(2);
        }

        let divisaC = () => {
            let valorDiv = totalAPagar() / (cambio);
            return valorDiv.toFixed(2)
        }

        let montoDivisa = () => (
            <React.Fragment>
                <Row>
                    <Col md = {6}>
                        <input type="number" maxLength= {10} onChange = {(e) => this.setState({
                            subTotal: e.target.value,
                            igtfV: (((e.target.value) * (datos.ValorIGTF)) / 100).toFixed(2)
                        })} value={subTotal} className="form-control" placeholder="Ej.: 35000"/>
                        <div className="text-muted" style={{fontSize: 9}}>Sub Total (En Bs.)</div>
                    </Col>
                    <Col md = {6}>
                        <input type="number" maxLength= {10} onChange = {(e) => this.setState({igtfV: e.target.value})} value = {igtfV} className="form-control" placeholder="IGTF" title ="Impuesto a Grandes Transacciones Financeieras"/>
                        <div className="text-muted" style={{fontSize: 9}}>IGTF (En Bs)</div>
                    </Col>
                    <Col md = {12} className = "custom-mt-10">
                        <div className = 'alert custom-alert-danger'>
                            <strong className = 'text-danger' style = {{fontSize: 11}}>
                                <Row>
                                    <Col md = {7}>TOTAL A PAGAR:</Col>
                                    <Col md = {5} align ="right">Bs. {totalAPagar()}</Col>
                                    <Col md = {7}>EN DIVISAS:<div>(Tasa del Sistema)</div></Col>
                                    <Col md = {5} align ="right">$ {divisaC()}</Col>
                                </Row>
                            </strong>
                        </div>
                    </Col>
                    <Col md={6}>
                        <input type="number" onChange ={this.cambiaValorDivisa()} value={divisas} className="form-control" placeholder="Ej.: 50"/>
                        <div className="text-muted" style={{fontSize: 9}}>Monto en Divisas ($)</div>  
                    </Col>
                    <Col md={6}>
                        <input type="text" maxLength= {50} disabled value={bsCambio} className="form-control"/>
                        <div className="text-muted" style={{fontSize: 9}}>Equivalencia en Bs. <strong>(Tasa del Sistema)</strong></div>
                    </Col>
                </Row>
                <div className="text-danger" style={{fontSize: 10, marginTop: 5}}>Tasa del Sistema: <strong>{cambio} Bs por Dólar</strong></div>
                <div className="text-danger" style={{fontSize: 10, marginTop: 5}}>Tasa B.C.V: <strong>{cambio2} Bs por Dólar</strong></div>
            </React.Fragment>
        )

        let conceptoEf = () => (
            <React.Fragment>
                <Col md={12}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
            </React.Fragment>
        )

        let contenidoGral = () => (
            <React.Fragment>
                <Col md={6} className="custom-mt-10">
                    <input maxLength= {20} type="text" value={num} onChange={this.cambiaValorM("num")} className="form-control" placeholder="Ej.: 001828212828"/>
                    <div className="text-muted" style={{fontSize: 9}}>(*) N° de Referencia</div>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
                <Col md={6} className="custom-mt-10 text-danger">(*) Monto:</Col>
                <Col md={6} className="custom-mt-10 text-danger">Concepto:</Col>
                <Col md={6}>
                    <div className="table-responsive">
                        <Table bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="number" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={6}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} rows={5} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
            </React.Fragment>
        )

        let contentPay = () => {
            switch (metodoSelect.label) {
                case "EFECTIVO":
                    return(
                        <Row>
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoPayEf()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "DIVISA":
                    return(
                        <Row> 
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoDivisa()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "TRANSFERENCIA":
                    return(
                        <Row>
                            <Col md={12}>
                                <Select
                                    isSearchable ={true}
                                    value={selectcuenta}
                                    onChange={this.valorCuenta}
                                    options={cuentas}
                                />
                                <div className="text-muted" style={{fontSize: 9}}>(*) Seleccciona el número de cuenta al cual hiciste la transferencia</div>
                            </Col>
                            {contenidoGral()}
                        </Row>
                    )
                case "DEBITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                case "CREDITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                default: return (
                    <div className="text-danger" align="center">Selecciona un Método de Pago</div>
                )
            }
        }

        let contenidoModal = () => (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={metodoSelect}
                            onChange={this.valorMetodo}
                            options={metodos}
                        />
                        <div className="text-muted" style={{fontSize: 9}}>Selecciona un Método de Pago</div>
                    </Col>
                    <Col md={6}>
                        <input type="text" value={factura} onChange={this.cambiaValorM("factura")} className="form-control" placeholder="N° de Factura"/>
                        <div className="text-danger" style={{fontSize: 9}}>Número de la Factura</div>
                    </Col>
                </Row>
                <div className="custom-mt-10">{contentPay()}</div>
            </React.Fragment>
        )

        let pagar = () => {
            if (this.state.modalPagoBtn1.disabled === true) return null
            if (metodoSelect.value === "") {
                toast.error("Debes elegir un método de pago",{autoClose: 4000});
                return null;
            }

            this.setState({
                modalPagoBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                PagarAranceles (datos.id, campos, "PAGO DE ARANCELES", (resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            modalPagoBtn1: {
                                icon:"fa fa-check",
                                text:"Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        this.setState({
                            openPago: false,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: "",
                        }, () => {
                            this.props.update()
                        })
                    }
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalPagoBtn1.icon}></i> {modalPagoBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openPago}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Registrar Pago de Aranceles de {datos.Estudiante}</div>}
                contenido = {contenidoModal()}      
                funcion1 = {pagar}
                funcion2 = {() => {this.setState({openPago: false})}}
            />
        );
    }

    modalInscripcion = () => {
        let {openMaterias} = this.state;
        let { datos } = this.props;

        let contenido = () => (
            <DatosInscripcion idEst={datos.id }
            tlf = {datos.Tfl1} cel = {datos.Tlf2}
            email = {datos.Email}
            EstCuenta ={true}/>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${datos.Estudiante}`}</div>}
                contenido = {contenido()}      
                funcion2 = {() => {this.setState({openMaterias: false})}}
            />
        );
    }

    modalPagoCompleto = () => {
        let {openPagoCompleto, concepto, factura, divisas, bsCambio, cambio, cuotasP, registrarAllCuotas, deudaT,
            selectcuenta, metodoPValue, metodoP, total, otro, otroMonto} = this.state;
        let { datos } = this.props;

        if (openPagoCompleto === false) return null;

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let addCuota = (num) => {
            let contenido = cuotasP
            contenido.push(num)
            this.setState({cuotasP: contenido})
        }

        let delCuota = (num) => {
            let contenido = cuotasP
            if (contenido.includes(num) === true) {
                let index = contenido.indexOf(num);
                if (index > -1) {
                    contenido.splice(index, 1);
                }
            }
            this.setState({cuotasP: contenido})
        }

        let contentCuotas = () => {
            let contenido = [];
            let TotalCuotas = 0;

            for (let i = 1; i < datos.Cuotas; i++){

                const search = (datos.CuotasCob).find(option => parseInt(option.cuota) === (i + 1));
                
                let cancel = 0;
                let clase = "text-muted";
                let switchCuota = "";
                let index = cuotasP.indexOf(i + 1);
                
                if (search === undefined) {
                    TotalCuotas += datos.ValorCuota;
                    cancel = datos.ValorCuota;

                    if (index === -1) cancel = 0; 
                    if (index === -1) TotalCuotas -= datos.ValorCuota;

                    clase = "text-primary";
                    switchCuota = (<SelectCuota cuota = {i + 1} addCuota = {(num) => addCuota(num)} delCuota = {(num) => delCuota(num)}/>);
                }
                
                contenido.push(
                    <tr>
                        <td align="center" style={styles}>
                            {switchCuota}
                        </td>
                        <td style={styles} className={clase}>Cuota {i + 1} de {datos.Cuotas} - Materias Inscritas</td>
                        <td width="100px" className={clase} style={stylesBs} align = "right">
                            {formatNumber(cancel)} Bs.
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(cancel)} Bs.</div> */}
                        </td>
                    </tr>
                )
            }

            contenido.push(
                <tr className="custon-back-color">
                    <td style={styles} colSpan = {2} align = "right"><strong>Total Cuotas</strong></td>
                    <td width="100px" style={stylesBs} align = "right">
                        <strong>{formatNumber(TotalCuotas)} Bs.</strong>
                        {/* <div style = {{fontWeight: "bold"}}><strong>{formatReconver(TotalCuotas)} Bs.</strong></div> */}
                    </td>
                </tr>
            )

            if (datos.Deuda > 0){
                contenido.push(
                    <tr style = {{backgroundColor: "#e3e3e3", color: "#000000"}}>
                        <td style={styles} colSpan = {2} align = "right"><strong>Cuotas + Deuda</strong></td>
                        <td width="100px" style={stylesBs} align = "right">
                            <strong>{formatNumber(TotalCuotas + datos.Deuda)} Bs.</strong>
                            {/* <div style = {{fontWeight: "bold"}}><strong>{formatReconver(TotalCuotas)} Bs.</strong></div> */}
                        </td>
                    </tr>
                )
            }

            if (metodoPValue.label === "DIVISA"){
                let igtf = () => {
                    let total = parseFloat(TotalCuotas) + parseFloat(datos.Deuda);
                    let porcentajeImp =  (total * (datos.ValorIGTF)) / 100;
                    return porcentajeImp.toFixed(2);
                }
        
                let totalAPagar = () => {
                    return ((parseFloat(TotalCuotas) + parseFloat(datos.Deuda)) + parseFloat(igtf())).toFixed(2);
                }
        
                let divisaC = () => {
                    let valorDiv = totalAPagar() / (cambio);
                    return valorDiv.toFixed(2)
                }

                contenido.push(
                    <tr>
                        <td style={styles} colSpan = {2} align = "right"><strong>IGTF</strong></td>
                        <td width="100px" style={stylesBs} align = "right">
                            <strong>{igtf()} Bs.</strong>
                            {/* <div style = {{fontWeight: "bold"}}><strong>{formatReconver(TotalCuotas)} Bs.</strong></div> */}
                        </td>
                    </tr>
                )

                contenido.push(
                    <tr style = {{backgroundColor: "#c35454", color: "#ffffff"}}>
                        <td style={styles} colSpan = {2} align = "right"><strong>TOTAL A PAGAR (BOLÍVARES | DIVISAS)</strong></td>
                        <td width="100px" style={stylesBs} align = "right">
                            <strong>Bs. {formatNumber(totalAPagar())} | $ {divisaC()}</strong>
                            {/* <div style = {{fontWeight: "bold"}}><strong>{formatReconver(TotalCuotas)} Bs.</strong></div> */}
                        </td>
                    </tr>
                )
            }

            return contenido
        }

        let calcula = (monto1) => {
            let total = 0
            cuotasP.forEach(() => { total += datos.ValorCuota; })
            return parseFloat(monto1) + total
        }

        let tipoPago = () => {
            switch (metodoPValue.label) {
                case "DIVISA": return (
                    <React.Fragment>
                        <Col md = {3} className = "custom-mt-10">
                            <input type="text" maxLength= {4} onChange ={this.cambiaValorDivisa()} value={divisas} className="form-control" placeholder="Ej.: 50"/>
                            <div className="text-muted" style={{fontSize: 9}}>Monto en Divisas</div>  
                        </Col>
                        <Col md = {5} className = "custom-mt-10">
                            <input type="text" maxLength= {50} disabled value={bsCambio} className="form-control"/>
                            <div className="text-muted" style={{fontSize: 9}}>Equivalencia en Bs.</div>
                        </Col>
                        <Col md={12}>
                            <div className="text-danger" align = "right" style={{fontSize: 10, marginTop: 5}}>Cambio del dia: <strong>{cambio} Bs por Dólar</strong></div>
                        </Col>
                    </React.Fragment>
                )
                case "EFECTIVO": return (
                    <React.Fragment>
                        <Col md ={8}>
                            <div className="table-responsive">
                                <Table bordered style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr>
                                            <td width= "50px" style={styles}>
                                                <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                            </td>
                                            <td width= "50%" style={styles}>
                                                <input type="text" maxLength= {10} value={(calcula(deudaT.totalGral)).toFixed(2)} disabled className="form-control" placeholder="Ej.: 35000"/>
                                                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                            </td>
                                            <td width= "50px" style={styles}>
                                                <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                            </td>
                                            <td width= "50%" style={styles}>
                                                <input type="number" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                                <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </React.Fragment>
                )
                default: return null;
            }
        }

        let contenido = () => (
            <div style = {{overflowY: "auto", overflowX: "hidden", maxHeight: "68vh", padding: 10}}>
                {/* <div className = "custom-alert-danger" align="right">Deuda Actual: <strong>{formatNumber(datos.Deuda)} Bs. | {formatReconver(datos.Deuda)} Bs.</strong></div> */}
                <div className = "custom-alert-danger" align="right">Deuda Actual: <strong>{formatNumber(datos.Deuda)} Bs.</strong></div>
                <div style = {{marginTop: 10, fontSize: 11}}>Cuotas por Cobrar:</div>
                <div className="table-responsive">
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="70px" align="center" style={styles}></td>
                                <td style={styles}><strong>Cuota</strong></td>
                                <td width="150px" style={styles} align = "right"><strong>Costo</strong></td>
                            </tr>
                            {contentCuotas()}
                        </tbody>
                    </Table>
                </div>
                <Row className = "custom-mt-10">
                    <Col md = {4}>
                        <Select
                            isSearchable ={true}
                            value={metodoPValue}
                            onChange={this.valorMetodoA}
                            options={metodoP}
                        />
                        <div className="text-muted" style={{fontSize: 9}}>Método de Pago</div>
                    </Col>
                    
                    <Col md = {5}>
                        <input type="text" maxLength= {50} onChange={this.cambiaValorM("concepto")} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}/>
                        <div className="text-muted" style={{fontSize: 9}}>Concepto</div>
                    </Col>
                    <Col md = {3}>
                        <input type="text" value={factura} onChange={this.cambiaValorM("factura")} className="form-control" placeholder="N° de Factura"/>
                        <div className="text-danger" style={{fontSize: 9}}>Número de la Factura</div>
                    </Col>
                    <Col md = {4} className = "custom-mt-10">
                        <DatePicker
                            clearIcon= {<i className="fa fa-times"></i>}
                            calendarIcon= {<i className="fa fa-calendar"></i>}
                            className="form-control"
                            onChange={this.cambiaFecha}
                            value={fecha}
                        />
                        <div className = "text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                    </Col>
                    {tipoPago()}
                </Row>

            </div>
        )

        let pagarAll = () => {
            if (registrarAllCuotas.disabled === true) return null;
            let campos = {fecha, concepto, factura, metodoP, divisas, cuotasP, deudaT, selectcuenta, total, otro, otroMonto, metodoPValue};

            this.setState({
                registrarAllCuotas: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                PagarAllCuotas(datos.id, campos, (resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            registrarAllCuotas: {
                                icon: "fa fa-money",
                                text: "Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        this.setState({
                            openPagoCompleto: false,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: "",
                            registrarAllCuotas: {
                                icon: "fa fa-money",
                                text: "Registrar",
                                disabled: false
                            }  
                        }, () => {
                            this.props.update()
                        })
                    }
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={registrarAllCuotas.icon}></i> {registrarAllCuotas.text}</React.Fragment>}
                large = "medium"
                isopen =  {openPagoCompleto}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Pagar las cuotas de ${datos.Estudiante}`}</div>}
                contenido = {contenido()}      
                funcion1 = {() => {pagarAll()}}
                funcion2 = {() => {this.setState({openPagoCompleto: false})}}
            />
        );
    }

    modalCuenta = () => {
        let { openCuenta, asientos, preloader, estadosHist, iconChevron3, asientosHist } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let contentEstado = () => {
            if (asientos.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">{preloader}</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                asientos.map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let contentEstadoHist = () => {
            if (asientosHist.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos históricos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            let num = 0
            return (
                asientosHist.map(option => {
                    num++;
                    return(
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    )
                })
            )
        }

        let histAsientos = () => {
            if (asientosHist.length === 0) return null;

            return(
                <PanelGroup accordion activeKey={estadosHist} className="custom-alert-danger">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estadosHist")}}>
                            <Panel.Title toggle className="text-danger">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        <strong><i className="fa fa-calendar"></i> Histórico de Asientos</strong>
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron3}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingTop:10}}>
                            <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                                <Table striped hover bordered style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                            <td width="40%" style={styles}><strong>Descripción</strong></td>
                                            <td width="12%" align="center" style={styles}><strong>Facturado</strong></td>
                                            <td width="12%" align="center" style={styles}><strong>Pagado</strong></td>
                                            <td width="16%" align="center" style={styles}><strong>Balance</strong></td>
                                            <td width="30px" align="center" style={styles}></td>
                                        </tr>
                                        {contentEstadoHist()}
                                    </tbody>
                                </Table>
                            </div>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            )
        }

        let contenidoModal = () => (
            <React.Fragment>
                {histAsientos()}
                <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                <td width="40%" style={styles}><strong>Descripción</strong></td>
                                <td width="12%" align="center" style={styles}><strong>Facturado</strong></td>
                                <td width="12%" align="center" style={styles}><strong>Pagado</strong></td>
                                <td width="16%" align="center" style={styles}><strong>Balance</strong></td>
                                <td width="30px" align="center" style={styles}></td>
                            </tr>
                            {contentEstado()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-times"></i> Cerrar</React.Fragment>}
                large = "large"
                isopen =  {openCuenta}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Estado de Cuenta de <strong>{this.props.datos.Estudiante}</strong></div>}
                contenido = {contenidoModal()}      
                funcion1 = {() => {this.setState({
                    openCuenta: false,
                    asientos: [],
                    preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando datos</React.Fragment>,
                })}}
            />
        );
    }

    render() {
        let { datos } = this.props;
        let { boton2, boton3 } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 11
        }
        
        let carrera = (carrera) => {
            if (carrera === "ESTUDIANTE RETIRADO") return ( <strong className="text-danger">{carrera}</strong> )
            return carrera
        }

        let menu = (
            <Popover bsSize="large" id="acciones">
                <div className="text-primary" style={{cursor:"pointer", fontSize: 12, padding: 5}} onClick = {
                    () => {
                        this.setState({
                            openPago: true,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: "",
                            modalPagoBtn1: {
                                icon:"fa fa-money",
                                text: "Registrar"
                            },
                        })
                    }}
                title="Registrar pago de este estudiante"><i className={boton2.icon}></i> {boton2.text}</div>
                <div style={{cursor:"pointer", fontSize: 12, padding: 5}} onClick = {
                    () => {
                        this.setState({
                            openPagoCompleto: true,
                            cuotasP:[],
                        })
                    }
                } title="Registrar pago de Todo el Semestre"><i className={boton3.icon}></i> {boton3.text}</div>
                <div className="text-danger" style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver Estado de Cuenta"  onClick={() => {
                    this.setState({
                        openCuenta: true
                    }, () => {
                        ConsultCuentaAdminHist (datos.id, (resp)=> {
                            this.setState({
                                asientos: resp[0],
                                asientosHist: resp[1]
                            })
                        })
                    }) }}><i className="fa fa-th-list"></i> Estado de Cuenta</div>
                <div className="text-warning" onClick ={() => {this.setState({openMaterias:true})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver las Materias Inscritas"><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>
                        <div className="text-danger" style={{fontSize: 10}}><strong>{datos.Ci} - {datos.Estudiante}</strong></div>
                        <div style={{fontSize: 10}}> <strong>Tlf 1: {datos.Tfl1} | Tlf 2: {datos.Tlf2}</strong></div>
                        <div className="text-primary" style={{fontSize: 10}}> <strong>Email:</strong> {datos.Email}</div>
                    </td>
                    <td align="center" style={styles2}>{carrera(datos.Carrera)}</td>
                    <td align="center" style={styles}>
                        {formatNumber(datos.Deuda)} Bs.
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(datos.Deuda)} Bs.</div> */}
                    </td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={menu}>
                            <button className="btn btn-primary" title= "Haz click aqui para ver las opciones disponibles" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalPago()}
                {this.modalPagoCompleto()}
                {this.modalInscripcion()}
                {this.modalCuenta()}
            </React.Fragment>
        );
    }
}
 
export default EstDeudasTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/EstDeudasTable.jsx